import { utils } from '@atlaskit/util-service-support';

// This type is inferred directly from
// https://developer.atlassian.com/platform/teams-internal/rest/v4/api-group-teams/#api-api-v4-teams-teamid-get-response

export var getTeamData = function getTeamData(url, teamAri) {
  var parts = teamAri.split('/');
  var id = parts[parts.length - 1];
  var options = {
    path: "/gateway/api/v4/teams/".concat(encodeURIComponent(id)),
    requestInit: {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    }
  };
  return utils.requestService({
    url: url
  }, options);
};